import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { APP_FALLBACK_LANGUAGE, APP_SUPPORTED_LANGUAGE_TAGS } from '@/lib/locale/constants';
import { buildI18nResourcesForSupportedLanguages, i18nLanguageBackend } from '@/lib/locale/registerI18nResources';

export const APP_NAMESPACES = [
  'common',
  'auth',
  'navigation',
  'profile',
  'workspace',
  'billing',
  'work',
  'assets',
  'inspections',
  'jobs',
  'lifecycleGate',
  'contacts',
  'home',
  'assistant',
  'activity',
  'schedule',
  'sites',
  'timeline',
  'copilot',
  'compliance',
  'guide',
  'packs',
  'notifications',
] as const;

export type AppNamespace = (typeof APP_NAMESPACES)[number];

// Web loads the translated packs on demand (registerI18nResources.web.ts); native has
// every pack bundled and no backend, exactly as before.
if (i18nLanguageBackend) i18n.use(i18nLanguageBackend);

void i18n.use(initReactI18next).init({
  compatibilityJSON: 'v4',
  resources: buildI18nResourcesForSupportedLanguages(),
  partialBundledLanguages: i18nLanguageBackend !== null,
  lng: APP_FALLBACK_LANGUAGE,
  fallbackLng: APP_FALLBACK_LANGUAGE,
  supportedLngs: [...APP_SUPPORTED_LANGUAGE_TAGS],
  defaultNS: 'common',
  ns: [...APP_NAMESPACES],
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;
